export const CardFrontIcon = ({ width, height, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 48}
      height={height || 29}
      viewBox="0 0 48 29"
      {...props}
    >
      <path d="M46.177 29H1.823C.9 29 0 28.13 0 27.187V1.813C0 .87.9 0 1.823 0h44.354C47.1 0 48 .87 48 1.813v25.375C48 28.13 47.1 29 46.177 29z" fill="#FFF" />
      <path d="M4.8 9.14c0-.427.57-.973 1.067-.973h7.466c.496 0 1.067.546 1.067.972v3.888c0 .425-.57.972-1.067.972H5.867c-.496 0-1.067-.547-1.067-.972v-3.89z" fill="#828282" />
      <rect fill="#828282" x="10.8" y="22.167" width="3.6" height="2.333" rx="1.167" />
      <rect fill="#828282" x="4.8" y="22.167" width="3.6" height="2.333" rx="1.167" />
      <path d="M6.55 16.333h34.9c.966 0 1.75.784 1.75 1.75 0 .967-.784 1.75-1.75 1.75H6.55c-.966 0-1.75-.783-1.75-1.75 0-.966.784-1.75 1.75-1.75z" fill="#828282" />
      <ellipse fill="#828282" cx="40.2" cy="6.417" rx="3" ry="2.917" />
    </svg>
  );
};
